module.exports = __webpack_public_path__ + "static/project-management-6016418002280419add615b92a2fffe9.svg";